<template>
  <div class="appointment-series-bubble">
    <BubbleHeader>{{message.message_description}}</BubbleHeader>
    <BubbleTextRow v-if="message.text"><BubbleTextMsg :text="message.text" /></BubbleTextRow>

    <MsgblContent :type="message.direction" v-if="message.showEntityLink">
      <MsgblLinkHeader icon="recurring-appointment" 
                       :title="message.appointment_title"
                       @click="navigateTo" />
    </MsgblContent>

    <MsgblContent :type="message.direction" v-if="message.showEntityCard">
      <MsgblLinkHeader icon="recurring-appointment" 
                       :title="message.appointment_title"
                       @click="navigateTo" />

      <MsgblTextRow>
        <MsgblTextLabel>{{$t('booking.info.starts_at')}}:</MsgblTextLabel>
        <MsgblTextValue>{{appointment.start_time_h}}</MsgblTextValue>
      </MsgblTextRow>
      <MsgblTextRow>
        <MsgblTextLabel>{{$t('booking.info.repeats')}}:</MsgblTextLabel>
        <MsgblTextValue>{{appointment.recurrence_description}}</MsgblTextValue>
      </MsgblTextRow>
      <MsgblTextRow v-if="showStaff">
        <MsgblTextLabel>{{$t('booking.info.staff')}}:</MsgblTextLabel>
        <MsgblTextValue>{{appointment.staff.display_name}}</MsgblTextValue>
      </MsgblTextRow>
      
      <MsgblActions :actions="actions" @action="actionClicked" />
    </MsgblContent>
  </div>
</template>

<script>
import {
  BubbleHeader,
  BubbleTextRow,
  BubbleTextMsg,
  MsgblContent,
  MsgblTextRow,
  MsgblLinkHeader,
  MsgblActions,
  MsgblTextLabel,
  MsgblTextValue,
} from './helpers'


export default {
  name: 'AppointmentSeriesBubble',
  components: {
    BubbleHeader,
    BubbleTextRow,
    BubbleTextMsg,
    MsgblContent,
    MsgblTextRow,
    MsgblLinkHeader,
    MsgblActions,
    MsgblTextLabel,
    MsgblTextValue,
  },
  props: {
    message: {
      type: Object,
      required: true,
    },
    showStaff: {
      type: Boolean,
      required: true,
      default: false
    },
  },
  data() {
    return {
      actions: [{name: 'view_first', name_h: this.$t("event.occurrences.view_first")}]
    }
  },
  computed: {
    appointment() {
      return this.message.messageable.appointment
    }
  },
  methods: {
    actionClicked(e) {
      this.navigateTo()
    },
    navigateTo() {
      this.$frontageApi.navigateTo('app.appointment.show', {uid: this.appointment.id})
    }
  }
}
</script>